import ApiEndpointConstants from "../constans/ApiEndpointConstants";
import api from "./API";

export const getOrder = (orderNo) => {
  return api.post(`${ApiEndpointConstants.GET_ORDER}`, {
    orderNo,
  });
};
